// components/atoms/InputField.tsx
import type { InputHTMLAttributes } from "react";
import type { UseFormRegisterReturn } from "react-hook-form";

type Props = {
    placeholder: string;
    error?: string;
    register: UseFormRegisterReturn;
} & InputHTMLAttributes<HTMLInputElement>;

export const InputField = ({ placeholder, register, error, className, ...rest }: Props) => (
    <div className={`w-full ${className ?? ""}`}>
        <input
            {...register}
            placeholder={placeholder}
            className={`form-control w-full p-5 text-base text-gray-900 bg-white border border-white rounded
          focus:outline-none 
          focus:border-[#8c8d90]
          focus:ring-4 
          focus:ring-[rgba(24,26,32,0.25)] 
          ${error ? "border-red-500" : ""}`}
            {...rest}
        />
        {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
);
